export default __webpack_public_path__ + "static/media/logomini.8208ee0b.png";